var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1183_2343)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.53554 15.1214L15.1213 6.53556C16.2929 5.36399 16.2929 3.4645 15.1213 2.29292L14.4142 1.58582L13.7071 0.878711C12.5355 -0.292862 10.636 -0.292865 9.46446 0.878712L0.878677 9.46451C0.316071 10.0271 1.68588e-07 10.7902 0 11.5858L6.32203e-07 13.6C7.58644e-07 14.9255 1.07451 16 2.4 16H4.41421C5.20986 16 5.97293 15.684 6.53554 15.1214ZM10.8787 2.29292C11.2692 1.9024 11.9024 1.9024 12.2929 2.29292L13 3.00003L13.7071 3.70714C14.0976 4.09766 14.0976 4.73083 13.7071 5.12135L12.6213 6.20712L9.7929 3.3787L10.8787 2.29292ZM8.37869 4.79291L2.29289 10.8787C2.10536 11.0663 2 11.3206 2 11.5858L2 13.6C2 13.821 2.17909 14 2.4 14H4.41421C4.67943 14 4.93378 13.8947 5.12132 13.7072L11.2071 7.62134L8.37869 4.79291Z",
    fill: "#2C2D2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1183_2343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ee5e5a0600cfe58379b2257ffb491764.svg";
export { ForwardRef as ReactComponent };